



















import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { CalendarLayer } from '@/model/document2/page/surface/design/layer/calendarLayer';
import { UnitHelper } from '@/helper/unitHelper';
import { MathHelper } from '@/helper/mathHelper';
import { UuidHelper } from '@/helper/uuidHelper';
import { DateHelper } from '@/helper/dateHelper';
import { StringHelper } from '@/helper/stringHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';

import { FontManager } from '@/model/fontManager/fontManager';

@Component({
    components: {
    },
})
export default class CalendarLayerDrawer extends Vue
{
    @Prop() private layer!: CalendarLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;
    // 直接印刷ではクライアントで処理するのでサーバー用のフォントになると困る
    @Prop({default : false}) private isRenderingOnClient!: boolean;

    // 文字位置調整のためにフォントサイズに掛け合わせる値
    private static readonly FONT_SIZE_FACTOR = 0.8;
    // 曜日のスペースの大きさは曜日のフォントサイズに対してどのくらいか
    private static readonly WEEK_DAY_SPACE_FACTOR = 1.2;
    // 年月のスペースの大きさは年月で大きい方のフォントサイズに対してどのくらいか
    private static readonly TITLE_SPACE_FACTOR = 1.5;

    private get x() { return this.layer.x; }
    private get y() { return this.layer.y; }
    private get width() { return this.layer.width; }
    private get height() { return this.layer.height; }
    private get daysFontSize() { return UnitHelper.convert(this.layer.dayFontSize, "pt", "mm"); }
    private get weekDayFontSize() { return UnitHelper.convert(this.layer.weekDayFontSize, "pt", "mm"); }
    private get yearFontSize() { return UnitHelper.convert(this.layer.yearFontSize, "pt", "mm"); }
    private get monthFontSize() { return UnitHelper.convert(this.layer.monthFontSize, "pt", "mm"); }
    private get strokeWidth() { return Math.max(0.01, this.layer.strokeWidth); }

    private get transform()
    {
        var transform = "";
        transform += "translate(" + this.offsetX + "," + this.offsetY + "),";
        transform += "scale(" + this.scale + "," + this.scale + "),";
        transform += "translate(" + this.layer.x + "," + this.layer.y + "),";
        transform += "rotate(" + this.layer.rotate + "),";
        transform += "translate(" + (-this.layer.x) + "," + (-this.layer.y) + ")";
        return transform;
    }

    // セル配列
    private get cellDataArray() : Array<CalendarLayerDrawerCellData>
    {
        var array : Array<CalendarLayerDrawerCellData> = [];

        // 1日の曜日取得
        var dayOfWeek = (new Date(this.layer.year, this.layer.month - 1, 1)).getDay();
        var startIndex = (dayOfWeek + 7 - this.layer.startWeekDay) % 7;
        // 月の日数
        var monthDays =(new Date(this.layer.year, this.layer.month, 0)).getDate();

        // X位置
        // Y位置
        var titleHeight = this.getTitleHeight();
        var weekDayHeight = this.getWeekDayHeight();
        var tableHeight = this.layer.height - titleHeight - weekDayHeight - this.strokeWidth;
        var cellX = this.x;
        var cellY = this.y + titleHeight + weekDayHeight;
        // セル一つあたりの幅
        var cellWidth = this.width / 7;
        var cellHeight = tableHeight / 6;
        var dateIndex = 0;
        for(var week = 0; week < 6; ++week)
        {
            for(var dayInWeek = 0; dayInWeek < 7; ++dayInWeek)
            {
                var cellData = new CalendarLayerDrawerCellData();
                cellData.x = cellX;
                cellData.y = cellY;
                cellData.width = cellWidth;
                cellData.height = cellHeight;
                if(startIndex <= dateIndex && dateIndex - startIndex + 1 <= monthDays)
                {
                    var day = dateIndex - startIndex + 1;
                    cellData.text = "" + day;
                    dayOfWeek = (new Date(this.layer.year, this.layer.month - 1, day)).getDay();
                    var isHoliday = DateHelper.isHolidayJapanese(this.layer.year, this.layer.month, day);
                    if(dayOfWeek == 0 || isHoliday) cellData.textColor = this.layer.sundayColor.hex;
                    else if(dayOfWeek == 6) cellData.textColor = this.layer.saturdayColor.hex;
                    else cellData.textColor = this.layer.weekDaysColor.hex;
                }
                array.push(cellData);

                cellX += cellWidth;
                dateIndex++;
            }
            if(monthDays < dateIndex - startIndex + 1) break;

            cellX = this.x;
            cellY += cellHeight;
        }

        return array;
    }

    private getTitleHeight()
    {
        var yearFontSize = this.layer.yearType != 0 ? this.layer.yearFontSize : 0;
        var monthFontSize = this.layer.monthFontSize;
        var titleHeight = UnitHelper.convert(Math.max(yearFontSize, monthFontSize), "pt", "mm") * CalendarLayerDrawer.TITLE_SPACE_FACTOR;
        return titleHeight;
    }

    private getWeekDayHeight()
    {
        var weekDayFontSize = this.layer.weekDayType != 0 ? this.layer.weekDayFontSize : 0;
        var weekDayHeight = UnitHelper.convert(weekDayFontSize, "pt", "mm") * CalendarLayerDrawer.WEEK_DAY_SPACE_FACTOR;
        return weekDayHeight;
    }

    private getDaysTextStyle(cellData : CalendarLayerDrawerCellData)
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var fontFamilyName = fontManager.getFontFamilyName(this.layer.dayFontId, true, this.isRendering && !this.isRenderingOnClient, false, this.isRenderingOnClient);
        var weight = "normal";
        var font = fontManager.getFontFamilyById(this.layer.dayFontId);
        if(font.weight == null) weight = this.layer.dayBold ? "bold" : "normal";
        else if(this.isRendering && !this.isRenderingOnClient) weight = font.weight >= 700 || this.layer.dayBold ? "bold" : "normal";
        else
        {
            if(this.layer.dayBold) weight = font.weight > 700 ? font.weight.toString() : "bold";
            else weight = font.weight.toString();
        }
        var style = this.layer.dayItalic ? "italic" : "normal";

        var textStyle = {
            "font-family" : fontFamilyName,
            "font-size" : this.daysFontSize,
            "font-weight" : weight,
            "font-style" : style,
            "fill" : cellData.textColor
        };
        return textStyle;
    }

    private getDaysTextX(cell)
    {
        var x = cell.x + this.strokeWidth;
        if(this.layer.horizontalAlignment == 1) x = cell.x + cell.width / 2;
        else if(this.layer.horizontalAlignment == 2) x = cell.x + cell.width - this.strokeWidth;
        return x;
    }
    
    private getDaysTextAnchor()
    {
        var anchor = "start";
        if(this.layer.horizontalAlignment == 1) anchor = "middle";
        else if(this.layer.horizontalAlignment == 2) anchor = "end"; 
        return anchor;
    }

    private getDaysTextY(cell)
    {
        var y = cell.y + this.strokeWidth + this.daysFontSize * CalendarLayerDrawer.FONT_SIZE_FACTOR;
        if(this.layer.verticalAlignment == 1) y = cell.y + cell.height / 2 + this.daysFontSize * CalendarLayerDrawer.FONT_SIZE_FACTOR / 2;
        else if(this.layer.verticalAlignment == 2) y = cell.y + cell.height - this.strokeWidth;
        return y;
    }

    private get weekDataArray() : Array<CalendarLayerDrawerWeekData>
    {
        var array : Array<CalendarLayerDrawerWeekData> = [];

        var cellWidth = this.width / 7;
        var cellX = this.x;
        var titleHeight = this.getTitleHeight();
        var baseY = this.y + titleHeight + this.weekDayFontSize * CalendarLayerDrawer.FONT_SIZE_FACTOR;
        for(var i = 0; i < 7; ++i)
        {
            var data = new CalendarLayerDrawerWeekData();
            var dayOfWeek = (this.layer.startWeekDay + i) % 7;
            data.text = DateHelper.getWeekdayString(this.layer.weekDayType, dayOfWeek);
            data.x = cellX + cellWidth / 2;
            data.y = baseY;
            if(dayOfWeek == 0) data.textColor = this.layer.sundayColor.hex;
            else if(dayOfWeek == 6) data.textColor = this.layer.saturdayColor.hex;
            else data.textColor = this.layer.weekDaysColor.hex;
            array.push(data);
            cellX += cellWidth;
        }
        return array;
    }

    private getWeekDayTextStyle(data : CalendarLayerDrawerWeekData)
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var fontFamilyName = fontManager.getFontFamilyName(this.layer.weekDayFontId, true, this.isRendering && !this.isRenderingOnClient, false, this.isRenderingOnClient);
        var weight = "normal";
        var font = fontManager.getFontFamilyById(this.layer.weekDayFontId);
        if(font.weight == null) weight = this.layer.weekDayBold ? "bold" : "normal";
        else if(this.isRendering && !this.isRenderingOnClient) weight = font.weight >= 700 || this.layer.weekDayBold ? "bold" : "normal";
        else
        {
            if(this.layer.weekDayBold) weight = font.weight > 700 ? font.weight.toString() : "bold";
            else weight = font.weight.toString();
        }
        var style = this.layer.weekDayItalic ? "italic" : "normal";

        var textStyle = {
            "font-family" : fontFamilyName,
            "font-size" : this.weekDayFontSize,
            "font-weight" : weight,
            "font-style" : style,
            "fill" : data.textColor
        };
        return textStyle;
    }

    private getYearText()
    {
        return DateHelper.getYearString(this.layer.yearType, this.layer.year, this.layer.month, 1);
    }

    private getYearX()
    {
        return this.x + this.width / 2;
    }

    private getTitleY()
    {
        var maxFontSize = this.layer.yearType == 0 ? this.monthFontSize : Math.max(this.yearFontSize, this.monthFontSize);
        return this.y + maxFontSize * CalendarLayerDrawer.FONT_SIZE_FACTOR;
    }

    private getYearTextStyle()
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var fontFamilyName = fontManager.getFontFamilyName(this.layer.yearFontId, true, this.isRendering && !this.isRenderingOnClient, false, this.isRenderingOnClient);
        var weight = "normal";
        var font = fontManager.getFontFamilyById(this.layer.yearFontId);
        if(font.weight == null) weight = this.layer.yearBold ? "bold" : "normal";
        else if(this.isRendering && !this.isRenderingOnClient) weight = font.weight >= 700 || this.layer.yearBold ? "bold" : "normal";
        else
        {
            if(this.layer.yearBold) weight = font.weight > 700 ? font.weight.toString() : "bold";
            else weight = font.weight.toString();
        }
        var style = this.layer.yearItalic ? "italic" : "normal";

        var textStyle = {
            "font-family" : fontFamilyName,
            "font-size" : this.yearFontSize,
            "font-weight" : weight,
            "font-style" : style,
            "fill" : this.layer.yearColor.hex
        };
        return textStyle;
    }

    private getYearTextDecoration()
    {
        return this.layer.yearUnderline ? "underline" : "none";
    }

    private getMonthText()
    {
        return DateHelper.getMonthString(this.layer.monthType, false, this.layer.month);
    }

    private getMonthX()
    {
        if(this.layer.yearType == 0)
        {
            // 年の表示なし
            return this.x + this.width / 2;
        }
        else
        {
            return this.x + this.width / 2 + this.monthFontSize * 0.5;
        }
    }

    private getMonthTextAnchor()
    {
        return this.layer.yearType == 0 ? "middle" : "start";
    }

    private getMonthTextStyle()
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var fontFamilyName = fontManager.getFontFamilyName(this.layer.monthFontId, true, this.isRendering && !this.isRenderingOnClient, false, this.isRenderingOnClient);
        var weight = "normal";
        var font = fontManager.getFontFamilyById(this.layer.monthFontId);
        if(font.weight == null) weight = this.layer.monthBold ? "bold" : "normal";
        else if(this.isRendering && !this.isRenderingOnClient) weight = font.weight >= 700 || this.layer.monthBold ? "bold" : "normal";
        else
        {
            if(this.layer.monthBold) weight = font.weight > 700 ? font.weight.toString() : "bold";
            else weight = font.weight.toString();
        }
        var style = this.layer.monthItalic ? "italic" : "normal";

        var textStyle = {
            "font-family" : fontFamilyName,
            "font-size" : this.monthFontSize,
            "font-weight" : weight,
            "font-style" : style,
            "fill" : this.layer.monthColor.hex
        };
        return textStyle;
    }

    private getMonthTextDecoration()
    {
        return this.layer.monthUnderline ? "underline" : "none";
    }
}

class CalendarLayerDrawerCellData
{
    public x : number = 0;
    public y : number = 0;
    public width : number = 0;
    public height : number = 0;
    public text : string = "";
    public textColor : string = "";
}

class CalendarLayerDrawerWeekData
{
    public x : number = 0;
    public y : number = 0;
    public text : string = "";
    public textColor : string = "";
}
